import { useContext } from "react";

import FilterContext, {
  Filters,
  SelectedFilters,
} from "../contexts/FilterContext";

interface UseFilterLogicReturn {
  filters: Filters;
  selectedFilters: SelectedFilters;
  selectColorFilter: (filter: string) => void;
  selectMaterialFilter: (filter: string) => void;
  selectStyleFilter: (filter: string) => void;
  selectDimensionFilter: (filter: string) => void;
  resetSelectedFilters: () => void;
  resetSelectedFiltersExceptDimensions: () => void;
  hasActiveFilters: boolean;
  activeFiltersCount: number;
}

function useFilterLogic(): UseFilterLogicReturn {
  const context = useContext(FilterContext);

  if (!context) {
    throw new Error("useFilterLogic must be used within a FilterProvider");
  }

  const {
    filters,
    selectedFilters,
    toggleColorFilter,
    toggleMaterialFilter,
    toggleStyleFilter,
    setDimensionFilter,
    resetSelectedFilters,
    resetSelectedFiltersExceptDimensions,
    hasActiveFilters,
    activeFiltersCount,
  } = context;

  return {
    filters,
    selectedFilters,
    selectColorFilter: toggleColorFilter,
    selectMaterialFilter: toggleMaterialFilter,
    selectStyleFilter: toggleStyleFilter,
    selectDimensionFilter: setDimensionFilter,
    resetSelectedFilters,
    resetSelectedFiltersExceptDimensions,
    hasActiveFilters,
    activeFiltersCount,
  };
}

export default useFilterLogic;
